"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "altavilla-vicentina": {
    "b148d7b2": [{
      "hkey": "2225f2e4",
      "slug": "altavilla-vicentina",
      "name": "Altavilla Vicentina",
      "primary": true,
      "skipSearch": false
    }],
    "tavernelle": [{
      "hkey": "2225f2e4",
      "slug": "altavilla-vicentina",
      "name": "Altavilla Vicentina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c394204f": [{
      "hkey": "2225f2e4",
      "slug": "altavilla-vicentina",
      "name": "Altavilla Vicentina",
      "primary": true,
      "skipSearch": false
    }],
    "valmarana": [{
      "hkey": "2225f2e4",
      "slug": "altavilla-vicentina",
      "name": "Altavilla Vicentina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;